/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return {
    stages: props.stages.map(stage => ({ ...stage, name: stage.text })),
    selected: props.selectedStages.map(stage => stage.id),
  }
}
